import { useEffect, useRef } from "react";
import { useMap } from "react-leaflet";
import L from "leaflet";
import { useStore } from "../../store";

interface AlarmLayers { marker: L.Marker; status: "WARNING" | "DEFENSE"; }

export default function AlarmOverlay() {
  const map           = useMap();
  const drones        = useStore(s => s.drones);
  const alarmedDrones = useStore(s => s.alarmedDrones);
  const ref           = useRef<Map<string, AlarmLayers>>(new Map());

  useEffect(() => {
    const cur = ref.current;

    alarmedDrones.forEach((status: any, droneId: string) => {
      const drone: any = drones.get(droneId);
      if (!drone || drone.lat == null || drone.lng == null) return;
      const lat = Number(drone.lat), lng = Number(drone.lng);
      const cls = "crosshair-" + (status === "DEFENSE" ? "defense" : "warning");

      const ex = cur.get(droneId);
      if (ex && ex.status === status) {
        ex.marker.setLatLng([lat, lng]);
      } else {
        if (ex) { ex.marker.remove(); }
        const icon = L.divIcon({
          html: `<div class="crosshair-ring ${cls}"><span class="ch-h"></span><span class="ch-v"></span></div>`,
          className: "", iconSize: [64, 64], iconAnchor: [32, 32],
        });
        const marker = L.marker([lat, lng], { icon, interactive: false }).addTo(map);
        cur.set(droneId, { marker, status });
      }
    });

    cur.forEach(({ marker }: AlarmLayers, id: string) => {
      if (!alarmedDrones.has(id)) { marker.remove(); cur.delete(id); }
    });
  }, [alarmedDrones, drones, map]);

  useEffect(() => () => {
    ref.current.forEach(({ marker }) => { marker.remove(); });
    ref.current.clear();
  }, []);

  return null;
}
